import * as React from "react";
import { courseInstructionPartViews } from "../../../../../utils/courseViews";
import { PreferredLocale } from "../../../../../utils/locales";
import { IQuestionPart } from "../../../types";
import { CourseInstructionPartOperations } from "../CourseInstructionPart.types";
import EditReinforcementRebuke from "./EditReinforcementRebuke";
import { EditTaskWrapperContent } from "./EditTaskWrapperContent";

export interface IChoiceExercisePartProps {
  exercisePart: IQuestionPart;
  currentLocale: PreferredLocale;
  edit: boolean;
  partOperations: CourseInstructionPartOperations;
}

export interface IChoiceExercisePartState {
  content: {
    rebuke: Nullable<string>;
    reinforcement: Nullable<string>;
    taskAfter: Nullable<string>;
    taskBefore: Nullable<string>;
  };
  edit: {
    taskAfter: boolean;
    taskBefore: boolean;
  };
}

export class ExerciseWrapper extends React.Component<IChoiceExercisePartProps, IChoiceExercisePartState> {
  private readonly defaultTaskBeforeText = "Click to add text";

  constructor(props: IChoiceExercisePartProps) {
    super(props);
    this.state = this.initState(props);
  }

  public componentDidUpdate(oldProps: IChoiceExercisePartProps) {
    if (changePartOrLocale(this.props, oldProps)) {
      this.setState({ content: this.initState(this.props).content });
    }
  }

  public initState(props: IChoiceExercisePartProps): IChoiceExercisePartState {
    return {
      content: {
        rebuke: courseInstructionPartViews.exerciseWrapping.localizedRebuke(props.exercisePart, props.currentLocale),
        reinforcement: courseInstructionPartViews.exerciseWrapping.localizedReinforcement(
          props.exercisePart,
          props.currentLocale
        ),
        taskAfter: courseInstructionPartViews.exerciseWrapping.localizedTaskAfter(
          props.exercisePart,
          props.currentLocale
        ),
        taskBefore: courseInstructionPartViews.exerciseWrapping.localizedTaskBefore(
          props.exercisePart,
          props.currentLocale
        ),
      },
      edit: {
        taskAfter: false,
        taskBefore: false,
      },
    };
  }

  public uploadImg = () => null;

  public toggleWrapperEdit = (key: string) => () =>
    this.props.edit
      ? this.setState({
          edit: { ...this.state.edit, [key]: !this.state.edit[key] },
        })
      : null;

  public getWrapperContent = (key: string) => () => this.state.content[key] || "";

  public setWrapperContent = (key: string) => (content: string, currentLocale: PreferredLocale) => {
    if (content !== this.state.content[key]) {
      this.setState({ content: { ...this.state.content, [key]: content } });
      this.props.partOperations.modifyChoiceExerciseWrapperContent(content, key, currentLocale);
    }
    this.toggleWrapperEdit(key)();
  };

  public setReinforcement = () => null;
  public setRebuke = () => null;

  public render() {
    const { children, currentLocale } = this.props;

    return (
      <>
        <EditTaskWrapperContent
          canEdit={this.state.edit.taskBefore}
          canToggle={this.props.edit}
          content={this.state.content.taskBefore || ""}
          currentLocale={currentLocale}
          placeholderText={this.defaultTaskBeforeText}
          getContent={this.getWrapperContent("taskBefore")}
          setContent={this.setWrapperContent("taskBefore")}
          toggleEdit={this.toggleWrapperEdit("taskBefore")}
        />
        {children}
        <EditTaskWrapperContent
          canEdit={this.state.edit.taskAfter}
          canToggle={this.props.edit}
          content={this.state.content.taskAfter || ""}
          currentLocale={currentLocale}
          placeholderText={this.defaultTaskBeforeText}
          getContent={this.getWrapperContent("taskAfter")}
          setContent={this.setWrapperContent("taskAfter")}
          toggleEdit={this.toggleWrapperEdit("taskAfter")}
        />
        {this.props.edit && (
          <EditReinforcementRebuke
            currentLocale={currentLocale}
            rebuke={this.state.content.rebuke}
            reinforcement={this.state.content.reinforcement}
            setRebuke={this.setWrapperContent("rebuke")}
            setReinforcement={this.setWrapperContent("reinforcement")}
          />
        )}
      </>
    );
  }
}

function changePartOrLocale(props: Readonly<IChoiceExercisePartProps>, oldProps: Readonly<IChoiceExercisePartProps>) {
  return props.exercisePart !== oldProps.exercisePart || props.currentLocale !== oldProps.currentLocale;
}
